import {IStationApi} from '../../../api/station-api.service';
import {IStation, IForecast} from '../../../api/api.types';
import * as moment from 'moment';

export interface IFormattedForecasts {
  pentadal: {
    label: string,
    forecastData: IForecast[],
    initialForecastData: IForecast[],
    customPeriodDate: Date
  },
  decade: {
    label: string,
    forecastData: IForecast[],
    initialForecastData: IForecast[],
    customPeriodDate: Date
  },
  monthly: {
    label: string,
    forecastData: IForecast[],
    initialForecastData: IForecast[],
    customPeriodDate: Date
  },
  seasonal: {
    label: string,
    forecastData: IForecast[],
    initialForecastData: IForecast[],
    customPeriodDate: Date
  },
  [key:string]: {
    label: string,
    forecastData: IForecast[],
    initialForecastData: IForecast[],
    customPeriodDate: Date
  }
}
export default class ForecatingProcessController {
    private static readonly $inject = ['stationApi', '$q'];

    selectedStation: IStation;
    selectedStationForecasts: IFormattedForecasts;
    loadingInProgress: boolean = false;
    maxDate: Date = new Date();
    showPeriodOptions: boolean = false;

    constructor(private stationApi: IStationApi, private $q:ng.IQService) {
    }

    onSelectedStationChange(selectedStation: IStation) {
      this.loadingInProgress = true;
      this.selectedStation = selectedStation;

      if (this.selectedStation) {
        const forecastPromises = [
          this.stationApi.getForecasts(this.selectedStation.id, 'pentadal'),
          this.stationApi.getForecasts(this.selectedStation.id, 'decade'),
          this.stationApi.getForecasts(this.selectedStation.id, 'monthly'),
          this.stationApi.getForecasts(this.selectedStation.id, 'seasonal')
        ];

        this.$q.all(forecastPromises)
          .then(([pentadalForecasts, decadalForecasts, monthlyForecast, seasonalForecast]: [IForecast[],IForecast[],IForecast[],IForecast[]]) => {
            const forecastsFormattedByFrequency: IFormattedForecasts = {
              pentadal: {
                label: "5-day",
                forecastData: pentadalForecasts,
                initialForecastData: angular.copy(pentadalForecasts),
                customPeriodDate: new Date()
              },
              decade: {
                label: "Decadal",
                forecastData: decadalForecasts,
                initialForecastData: angular.copy(decadalForecasts),
                customPeriodDate: new Date()
              },
              monthly: {
                label: "Monthly",
                forecastData: monthlyForecast,
                initialForecastData: angular.copy(monthlyForecast),
                customPeriodDate: new Date()
              },
              seasonal: {
                label: "Seasonal",
                forecastData: seasonalForecast,
                initialForecastData: angular.copy(seasonalForecast),
                customPeriodDate: new Date()
              },
            };
            
            this.selectedStationForecasts = forecastsFormattedByFrequency;
            this.loadingInProgress = false;
          })  
      } else {
        this.loadingInProgress = false;
      }
    }

    onPreviousPeriodClick(frequency: string) {
      this.loadingInProgress = true;
      this.stationApi.getForecasts(
        this.selectedStation.id,
        frequency,
        this.selectedStationForecasts[frequency].forecastData[0].forecastingPeriodStart,
        true
      )
        .then((prevForecastData: IForecast[])=>{
          this.selectedStationForecasts[frequency].forecastData = prevForecastData;
          this.loadingInProgress = false;  
        })
    }

    onChosenPeriodDateClick(frequency: string) {
      this.loadingInProgress = true;
      this.stationApi.getForecasts(
        this.selectedStation.id,
        frequency,
        new Date(moment(this.selectedStationForecasts[frequency].customPeriodDate).format("YYYY-MM-DD")),
        false
      )
        .then((forecastData: IForecast[])=>{
          this.selectedStationForecasts[frequency].forecastData = forecastData;
          this.loadingInProgress = false;  
        })
    }

    onCurrentPeriodClick(frequency: string) {
      this.selectedStationForecasts[frequency].forecastData = 
        angular.copy(this.selectedStationForecasts[frequency].initialForecastData);
    }

    isForecastDataPresent(forecastData: IForecast[]) {
      let hasForecastData = false;
      if (forecastData && forecastData.length) {
        forecastData.forEach((forecastDataItem) => {
          if (forecastDataItem.forecasts.length) {
            forecastDataItem.forecasts.forEach((forecast) => {
              if (forecast.forecastResults.length) {
                hasForecastData = true;
              }
            })
          } 
        });
      }
      return hasForecastData;
    }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/forecasting/process/forecasting-process.controller.ts
 **/